<template>
    <!--   营销管理－优惠券管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this, 'couponIndex')">
        <div slot="header">
            <a-form :form="form" layout="inline" class="store-one-form">
                <a-form-item label="优惠券名称">
                    <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                </a-form-item>
                <a-form-item label="优惠券状态">
                    <a-select allowClear placeholder="请选择" v-decorator="['status']" @select="search">
                        <a-select-option value="2">已生效</a-select-option>
                        <a-select-option value="1">未生效</a-select-option>
                        <a-select-option value="3">已失效</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="优惠券类型">
                    <a-select allowClear placeholder="请选择" v-decorator="['couponType']" @select="search">
                        <a-select-option value="1">满减券</a-select-option>
                        <a-select-option value="2">折扣券</a-select-option>
                        <a-select-option value="3">兑换券</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="生效时间">
                    <a-range-picker
                        style="width:282px"
                        format="YYYY/MM/DD"
                        v-decorator="['selectDate']"
                        @change="search"
                    />
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>

        <div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <router-link slot="tabBarExtraContent" :to="{name: 'newCoupon'}">
                    <a-button v-if="getBtnByAuth('newCouponNew')" type="primary">新增优惠券</a-button>
                </router-link>
                <a-alert v-if="noTitleKey == 10" class="mb16" message="租赁优惠券不对押金有效，仅对收银台租赁商品有效。即：押金按实际付和退，收银台租赁商品按优惠券计算优惠价格。" />
                <a-table
                    :bordered="true"
                    :dataSource="dataSource"
                    :columns="columns"
                    :scroll="{ x: 800 , y: 580}"
                    :pagination="pagination"
                    @change="changePage"
                    :rowKey="(record,index) => index"
                >
                    <span slot="index" slot-scope="a,item,i">{{i+1}}</span>
                    <span slot="couponType" slot-scope="couponType">{{['','满减劵','折扣劵', "兑换券"][couponType]}}</span>
                    <span slot="couponRule" slot-scope="couponRule">{{couponRule || "-"}}</span>
                    <template slot="suitGoodsDesc" slot-scope="suitGoodsDesc, row">
                        <span v-if="suitGoodsDesc">{{suitGoodsDesc}} <a @click="getSuitMeal(row)" class="text-primary">查看</a></span>
                        <span v-else>-</span>
                    </template>
                    <span slot="status" slot-scope="status">{{['','未生效','已生效','已失效'][status]}}</span>
                    <span slot="isShowMall" slot-scope="isShowMall">{{['否','是'][isShowMall] || "-"}}</span>
                    <span slot="num" slot-scope="num">{{!num ? "-" : num === -1 ? '不限量' : num}}</span>
                    <span slot="receiveNum" slot-scope="receiveNum">{{!receiveNum ? "-" : receiveNum === -1 ? '不限量' : receiveNum}}</span>
                    <span slot="action" slot-scope="a,item">
                        <a v-if="getBtnByAuth('couponNewDetail')" @click="couponDetail(item.id)" class="text-primary">详情</a>
                        <a v-if="getBtnByAuth('editCouponNew')" @click="couponEdit(item.id)" class="text-primary"><a-divider type="vertical" />编辑</a>
                        <a v-if="getBtnByAuth('couponNewShow')" @click="couponUser(item.id)" class="text-primary"><a-divider type="vertical" />领取用户查看</a>
                        <!-- <a v-if="getBtnByAuth('couponNewDelete')" class="text-disabled"><a-divider type="vertical" />删除</a> -->
                        <a-popconfirm
                            v-if="getBtnByAuth('couponNewDelete')"
                            title="本次删除不影响已领取用户的优惠券，系统会自查优惠券是否与活动关联，若关联则无法删除。请确认是否删除？"
                            @confirm="couponDelete(item.id)"
                            >
                            <a-divider type="vertical" />
                            <a class="text-primary">删除</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
        </div>
        <!--  门店票列表选择弹框 -->
        <a-modal
            title='查看适用商品'
            :width="980"
            :visible="visibleMeals"
            @cancel="visibleMeals = false"
            @ok="visibleMeals = false"
            >
            <div>
                <a-table
                    style="word-break:break-all;"
                    class="mt16"
                    :scroll="{ y: 280 }"
                    bordered
                    :columns="columnsMeal"
                    :dataSource="suitMealList"
                    :pagination="false"
                    >
                    <span slot="onShelvesStatus" slot-scope="a">{{['上架中', '已下架',][Number(a)]}}</span>
                    <span slot="sellPrice" slot-scope="sellPrice">{{sellPrice | myToFixed2}}</span>
                </a-table>
            </div>
        </a-modal>
            <common-tips ref="commonTips">
                <template slot="context">
                    <div class="mb8"><a-icon type="info-circle" theme="filled" style="color: #F59A23;" /><span class="ml8">{{ delErrMsg }}</span></div>
                    <div>{{ delSolveFunction }}</div>
                </template>
            </common-tips>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from "moment";
    import CommonTips from '@/components/common/common-tips.component'

    const tabListNoTitle = [
        {
            key: '1',
            tab: '门票优惠券',
            columnLine: columns
        },
        {
            key: '2',
            tab: '餐饮优惠券',
            columnLine: columns
        },
        {
            key: '3',
            tab: '零售优惠券',
            columnLine: columns
        },
        {
            key: '4',
            tab: '课程优惠券',
            columnLine: columns
        },
        {
            key: '10',
            tab: '租赁优惠券',
            columnLine: columns
        }
    ]
    const columns = [
        {
            title: "序号",
            dataIndex: "index",
            scopedSlots: { customRender: "index" }
        },
        {
            title: "优惠券名称",
            dataIndex: "name"
        },
        {
            title: "适用类型",
            dataIndex: "suitName"
        },
        {
            title: "是否在积分商城售卖",
            dataIndex: "isShowMall",
            scopedSlots: { customRender: "isShowMall" }
        },
        {
            title: "适用范围",
            dataIndex: "suitRangeName",
        },
        {
            title: "优惠券类型",
            dataIndex: "couponType",
            scopedSlots: { customRender: "couponType" }
        },
        {
            title: "优惠规则",
            dataIndex: "couponRule",
            scopedSlots: { customRender: "couponRule" }
        },
        {
            title: "适用商品",
            dataIndex: "suitGoodsDesc",
            scopedSlots: { customRender: "suitGoodsDesc" }
        },
        {
            title: "生效时间",
            dataIndex: "effectiveTime"
        },
        {
            title: "优惠券状态",
            dataIndex: "status",
            scopedSlots: { customRender: "status" }
        },
        {
            title: "优惠券数量",
            dataIndex: "num",
            scopedSlots: { customRender: "num" }
        },
        {
            title: "已领取数量",
            dataIndex: "receiveNum",
            scopedSlots: { customRender: "receiveNum" }
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const columnsMeal = [
        {
            title: "门店名称",
            dataIndex: "shopName",
        },
        {
            title: "商品分类",
            dataIndex: "goodsCategory"
        },
        {
            title: "商品名称",
            dataIndex: "goodsName"
        },
        {
            title: "上架状态",
            dataIndex: "onShelvesStatus",
            scopedSlots: { customRender: "onShelvesStatus" }
        },
        {
            title: "商品售价(元)",
            dataIndex: "sellPrice",
            scopedSlots: { customRender: "sellPrice" }
        },
    ];
    export default {
        name: "coupon",
        components: {
            CommonTips
        },
        props: {},
        data() {
            return {
                visibleMeals: false,
                suitMealList: [],
                dataSource: [],
                columns,
                columnsMeal,
                tabListNoTitle: tabListNoTitle,
                noTitleKey: '1',
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                delErrMsg: '',
                delSolveFunction: ''
            };
        },
        watch: {
            $route: function(newVal, oldVal) {
                if (newVal.name === "couponIndex") {
                    this.getList();
                }
            }
        },
        methods: {
            getSuitMeal(item) {
                this.$api.changeCode.querySuitDish({
                    params: {
                        couponId: item.id,
                    }
                }).then(res => {
                    this.visibleMeals = true;
                    this.suitMealList = res;
                })
            },
            handleReset() {
                this.form.resetFields();
                this.getList()
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey;
                this.pagination.current = 1;
                this.getList();
            },
            //获取列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const rangeValue = values['selectDate'] ? values['selectDate'] : [];
                    values.validStartTime = rangeValue.length > 0 ? rangeValue[0].format('YYYY-MM-DD 00:00:00') : undefined;
                    values.validEndTime = rangeValue.length > 0 ? rangeValue[1].format('YYYY-MM-DD 23:59:59') : undefined;
                    delete values.selectDate;
                    values.suitType = this.noTitleKey;
                    this.$api.changeCode.newCouponList({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        })
                    }).then(res => {
                        this.dataSource = res.list;
                        this.pagination.total = res.total;
                    });
                });
            },
            // 时间选择
            moment,
            onChangePicker(value, data) {
                this.validEndTime = data[0];
                this.validStartTime = data[1];
            },

            couponDetail(id) {
                this.$router.push({
                    name: "newCouponDetail",
                    query: { id: id }
                });
            },
            couponEdit(id) {
                this.$router.push({
                    name: "newCouponEdit",
                    query: { id: id }
                });
            },
            couponUser(id) {
                this.$router.push({
                    name: "couponShow",
                    query: { id: id }
                });
            },
            couponDelete(id) {
                this.$api.changeCode.newCouponDelete({
                    params: {id: id}
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                }).catch(err => {
                    let regExp = /【.*】/;
                    if (err && err.message.indexOf('已参与兑换礼券：') > -1) {
                        this.$message.destroy();
                        let exchangeGiftTicketName = err.message.match(regExp)[0];
                        this.delErrMsg = err.message;
                        this.delSolveFunction = `请到兑换礼券管理页面停用并删除${exchangeGiftTicketName}后在进行此操作。`
                        this.$refs.commonTips.open();
                    } else if (err && err.message.indexOf('已参与买赠活动：') > -1) {
                        this.$message.destroy();
                        this.delErrMsg = err.message;
                        this.delSolveFunction = ''
                        this.$refs.commonTips.open();
                    }
                });
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        }
    };
</script>
<style lang="scss">
    .container {
        background: #fff;
    }
</style>
